<template>
  <div class="p-4">
    <div class="row">
      <div class="col-6">
        <div><strong>Inbound #: </strong>{{ order.number }}</div>
        <div><strong>Status: </strong>{{ order.status.name }}</div>
        <div><strong>Client: </strong>{{ order.client.name }}</div>
        <div><strong>Created: </strong>{{ createdAt }}</div>
        <div><strong>PO Number: </strong>{{ order.po_number }}</div>
        <div><strong>Container: </strong>{{ order.container_number }}</div>
      </div>
      <div class="col-6">
        <div><strong>Carrier: </strong>{{ order.carrier.name }}</div>
        <div><strong>Tracking #: </strong>{{ order.tracking_number }}</div>
        <div><strong>ETA: </strong>{{ eta }}</div>
        <div><strong>Pallets: </strong>{{ order.total_pallets }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'


export default {
  name: 'order-meta',

  props: {
    order: Object
  },

  components: {

  },

  computed: {
    eta() {
      return moment(this.order.eta).format("l")
    },

    createdAt() {
      return moment(this.order.created_at).format("l")
    }
  },

  methods: {
    calendar(date) {
      return moment(date).calendar()
    }
  }

}
</script>